/* Elegance Coque — page « Toutes nos coques » : choix de l'iPhone (mémorisé), Filtrer (style), Trier,
   pastilles des couleurs réellement disponibles, cœur favoris, bouton « Choisir mon modèle » / « Ajouter ».
   Données réelles uniquement : variantes, photos de variantes, collections et panier Shopify. */
(function () {
  var d = document, W = window;
  var root = d.querySelector('[data-ecx]');
  if (!root || root.__ecx) { return; }
  root.__ecx = true;
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  var MOPT = 'Modèle iPhone';
  var COLORS = { 'violet': '#7b5aa6', 'rose': '#f2b5c4', 'bleu': '#2f5da8', 'noir': '#111111', 'vert': '#2e6b4a', 'blanc': '#ffffff', 'marron': '#6b4a35', 'gris': '#9a9a9a', 'gris anthracite': '#3d3f42', 'bleu marine': '#14213d', 'marron rosé': '#b98b82', 'beige gris': '#c9bfae', 'blanc gris': '#e8e6e1', 'orange': '#e8742a', 'taupe': '#8b7b6e', 'noir fumé': '#2b2b2d', 'transparent': '#f1f1f1', 'beige check': '#d8c3a0', 'gris oblique': '#8f9296', 'marron ff': '#6b4a35', 'monogram classique': '#8a5a2b', 'grand monogramme': '#7a4b22', 'prune': '#5e2a4a', 'doré': '#d4af37', 'argent': '#c0c0c0' };
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var MAXSW = 5;

  function qa(r, s) { return [].slice.call((r || d).querySelectorAll(s)); }
  function esc(t) { var s = d.createElement('span'); s.textContent = t == null ? '' : String(t); return s.innerHTML; }
  function dh(c) { c = Math.round(Number(c) || 0); var w = Math.floor(c / 100), r = c % 100; return String(w).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (r ? ',' + (r < 10 ? '0' : '') + r : '') + ' DH'; }
  function mh(v) { return 'iphone-' + String(v || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').replace(/-(normal|standard)$/, ''); }
  function sized(u, w) { if (!u) { return ''; } return u.replace(/([?&])width=\d+/, '$1width=' + w); }

  var mSel = root.querySelector('[data-ecx-m]'), mFace = root.querySelector('[data-ecx-mface]'), mClr = root.querySelector('[data-ecx-mclear]');
  var sortSel = root.querySelector('[data-ecx-sort]'), sortFace = root.querySelector('[data-ecx-sortface]');
  var grid = root.querySelector('[data-ecx-grid]'), countEl = root.querySelector('[data-ecx-count]');
  var empty = root.querySelector('[data-ecx-empty]'), chips = root.querySelector('[data-ecx-chips]');
  var fBtn = root.querySelector('[data-ecx-fopen]'), fBadge = root.querySelector('[data-ecx-fbadge]'), fdlg = root.querySelector('[data-ecx-fdlg]');
  if (!grid || !mSel) { return; }
  var WA = root.getAttribute('data-wa') || '';
  var state = { m: '', s: {} }, draft = {};

  /* ---------- cartes ---------- */
  var cards = qa(grid, '[data-ecx-card]').map(function (li, i) {
    var data = {};
    try { data = JSON.parse(li.querySelector('[data-ecx-d]').textContent) || {}; } catch (e) {}
    var o = data.o || [], mi = o.indexOf(MOPT), ci = -1;
    o.forEach(function (n, k) { if (/^(couleur|color|colour)$/i.test(n)) { ci = k; } });
    var vs = (data.v || []).map(function (a) { return { id: a[0], opts: [a[1], a[2], a[3]], av: !!a[4], img: a[5] || '', p: a[6] }; });
    var models = {}, order = [];
    if (mi > -1) {
      vs.forEach(function (v) {
        var k = mh(v.opts[mi]); if (!models[k]) { models[k] = { val: v.opts[mi], av: false }; order.push(k); }
        if (v.av) { models[k].av = true; }
      });
    } else {
      (data.tg || []).forEach(function (t) { if (/^iphone\s/i.test(t)) { var k = mh(String(t).replace(/^iphone\s*/i, '')); if (!models[k]) { models[k] = { val: '', av: true }; order.push(k); } } });
    }
    var img = li.querySelector('.ecx-card__img img');
    var heart = li.querySelector('[data-lwl]');
    var c = {
      el: li, i: i, h: li.getAttribute('data-h'), t: li.getAttribute('data-title') || '', url: li.getAttribute('data-url'),
      p: Number(li.getAttribute('data-p')) || 0, pub: Number(li.getAttribute('data-t')) || 0, s: ' ' + (li.getAttribute('data-s') || '') + ' ',
      o: o, mi: mi, ci: ci, vs: vs, models: models, morder: order, img: img,
      src: img ? img.getAttribute('src') : '', srcset: img ? (img.getAttribute('srcset') || '') : '',
      color: '', sw: li.querySelector('[data-ecx-sw]'), btn: li.querySelector('[data-ecx-add]'), links: qa(li, '[data-ecx-link]'),
      avail: vs.some(function (v) { return v.av; })
    };
    if (heart) { heart.__lwl = { h: c.h, t: c.t, i: c.src }; }
    return c;
  });

  function modelVal(c, m) { return m && c.models[m] ? c.models[m].val : ''; }
  function fits(c, v, m, color) {
    if (c.mi > -1 && m && v.opts[c.mi] !== modelVal(c, m)) { return false; }
    if (c.ci > -1 && color && v.opts[c.ci] !== color) { return false; }
    return true;
  }
  /* couleurs réellement disponibles (pour le modèle choisi s'il y en a un) */
  function colorsFor(c, m) {
    if (c.ci < 0) { return []; }
    var out = [], seen = {};
    c.vs.forEach(function (v) {
      if (!v.av || !fits(c, v, m, '')) { return; }
      var n = v.opts[c.ci]; if (seen[n]) { if (!seen[n].img && v.img) { seen[n].img = v.img; } return; }
      seen[n] = { name: n, img: v.img }; out.push(seen[n]);
    });
    /* photo de la couleur : celle de n'importe quelle variante de cette couleur si le modèle n'en a pas */
    out.forEach(function (x) { if (!x.img) { c.vs.some(function (v) { if (v.opts[c.ci] === x.name && v.img) { x.img = v.img; return true; } return false; }); } });
    return out;
  }
  function variantFor(c, m, color) {
    if (c.mi > -1 && !m) { return null; }
    if (c.ci > -1 && !color) { return null; }
    return c.vs.filter(function (v) { return v.av && fits(c, v, m, color); })[0] || null;
  }
  function needsModel(c) { return c.mi > -1; }

  /* ---------- pastilles ---------- */
  function swatchHtml(x, on) {
    var bg = x.img ? 'background-image:url(' + esc(sized(x.img, 120)) + ')' : 'background-color:' + (COLORS[String(x.name).toLowerCase()] || '#cfc8bb');
    return '<button type="button" class="ecx-sw__b' + (x.img ? ' has-img' : '') + '" data-ecx-color="' + esc(x.name) + '" aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + esc(x.name) + '" title="' + esc(x.name) + '"><span style="' + bg + '"></span></button>';
  }
  function renderSwatches(c) {
    if (!c.sw) { return; }
    var list = colorsFor(c, state.m);
    if (c.color && !list.some(function (x) { return x.name === c.color; })) { c.color = ''; showColor(c); }
    if (list.length < 2) { c.sw.innerHTML = list.length === 1 ? '<span class="ecx-sw__one">' + esc(list[0].name) + '</span>' : ''; return; }
    var html = '', shown = list.slice(0, MAXSW);
    if (c.color && shown.every(function (x) { return x.name !== c.color; })) { shown[shown.length - 1] = list.filter(function (x) { return x.name === c.color; })[0]; }
    shown.forEach(function (x) { html += swatchHtml(x, x.name === c.color); });
    if (list.length > MAXSW) { html += '<a class="ecx-sw__more" href="' + esc(c.url) + '" aria-label="Voir les ' + list.length + ' couleurs">+' + (list.length - MAXSW) + '</a>'; }
    html += '<span class="ecx-sw__name" aria-live="polite">' + esc(c.color) + '</span>';
    c.sw.innerHTML = html;
  }
  function showColor(c) {
    var x = c.color ? colorsFor(c, state.m).filter(function (y) { return y.name === c.color; })[0] : null;
    if (c.img) {
      if (x && x.img) { c.img.removeAttribute('srcset'); c.img.setAttribute('src', x.img); }
      else { c.img.setAttribute('src', c.src); if (c.srcset) { c.img.setAttribute('srcset', c.srcset); } }
    }
    var v = c.vs.filter(function (y) { return fits(c, y, state.m, c.color) && (y.av || !c.avail); })[0];
    var href = c.url + ((c.color || state.m) && v ? '?variant=' + v.id : '');
    c.links.forEach(function (a) { a.setAttribute('href', href); });
    var nm = c.sw && c.sw.querySelector('.ecx-sw__name'); if (nm) { nm.textContent = c.color; }
  }

  /* ---------- bouton de la carte ---------- */
  function btnState(c) {
    var b = c.btn; if (!b) { return; }
    var m = state.m, mode = 'choose', label = 'Choisir mon modèle', dis = false;
    if (!c.avail) { label = 'Épuisé'; dis = true; mode = 'none'; }
    else if (!needsModel(c)) { mode = 'add'; label = 'Ajouter'; }
    else if (m && c.models[m]) {
      if (c.models[m].av) { mode = 'add'; label = 'Ajouter'; } else { mode = 'none'; label = 'Épuisé pour ce modèle'; dis = true; }
    }
    b.setAttribute('data-mode', mode); b.disabled = dis;
    b.classList.toggle('is-add', mode === 'add');
    b.innerHTML = (mode === 'add' ? BAG : '') + '<span>' + esc(label) + '</span>';
    b.setAttribute('aria-label', label + ' — ' + c.t);
  }

  /* ---------- filtres, tri, compteur ---------- */
  function styles(st) { return Object.keys(st).filter(function (k) { return st[k]; }); }
  function passes(c, m, st) {
    if (m && !c.models[m]) { return false; }
    var ss = styles(st);
    if (ss.length && !ss.some(function (s) { return c.s.indexOf(' ' + s + ' ') > -1; })) { return false; }
    return true;
  }
  function optText(sel, v) { var o = [].filter.call(sel.options, function (x) { return x.value === v; })[0]; return o ? o.text : ''; }
  function hasOpt(sel, v) { return !!v && [].some.call(sel.options, function (o) { return o.value === v; }); }
  function plural(n) { return n + ' coque' + (n > 1 ? 's' : ''); }

  function apply() {
    var m = state.m, n = 0;
    cards.forEach(function (c) {
      var ok = passes(c, m, state.s);
      c.el.hidden = !ok; if (ok) { n++; }
      renderSwatches(c); showColor(c); btnState(c);
    });
    var mode = sortSel ? sortSel.value : 'manual';
    cards.slice().sort(function (a, b) {
      if (mode === 'new') { return b.pub - a.pub || a.i - b.i; }
      if (mode === 'price-asc') { return a.p - b.p || a.i - b.i; }
      if (mode === 'price-desc') { return b.p - a.p || a.i - b.i; }
      return a.i - b.i;
    }).forEach(function (c) { grid.appendChild(c.el); });
    countEl.textContent = plural(n);
    /* sélecteur d'iPhone */
    mSel.value = m;
    mFace.textContent = m ? 'Mon modèle : ' + optText(mSel, m) : (mFace.getAttribute('data-default') || '');
    mFace.classList.toggle('is-chosen', !!m);
    root.classList.toggle('has-model', !!m);
    if (mClr) { mClr.hidden = !m; }
    if (sortFace && sortSel) { var so = sortSel.options[sortSel.selectedIndex]; sortFace.textContent = sortSel.value === 'manual' ? 'Trier' : (so.getAttribute('data-short') || so.text); sortFace.parentNode.classList.toggle('is-on', sortSel.value !== 'manual'); }
    /* filtres actifs */
    var ss = styles(state.s);
    fBadge.textContent = ss.length; fBadge.hidden = !ss.length; fBtn.classList.toggle('is-on', !!ss.length);
    var ch = '';
    ss.forEach(function (s) { ch += '<button type="button" class="ecx-chip" data-ecx-unstyle="' + esc(s) + '" aria-label="Retirer le filtre ' + esc(styleName(s)) + '">' + esc(styleName(s)) + '</button>'; });
    if (ss.length > 1) { ch += '<button type="button" class="ecx-chip__all" data-ecx-unstyle="*">Tout effacer</button>'; }
    chips.innerHTML = ch; chips.hidden = !ss.length;
    /* aucun résultat */
    if (n) { empty.hidden = true; grid.hidden = false; }
    else {
      grid.hidden = true; empty.hidden = false;
      var lab = m ? optText(mSel, m) : '';
      var inModel = m ? cards.filter(function (c) { return c.models[m]; }).length : 1;
      var html = '';
      if (m && !inModel) {
        html = '<p>Aucune coque n’est encore disponible pour l’' + esc(lab) + '.</p><div class="ecx-empty__acts"><button type="button" class="ecx-empty__b is-dark" data-ecx-reset-all>Voir toutes les coques</button>' + (WA ? '<a class="ecx-empty__b" href="' + esc(WA) + '?text=' + encodeURIComponent('Bonjour Elegance Coque, avez-vous des coques pour ' + lab + ' ?') + '" target="_blank" rel="noopener">Nous écrire sur WhatsApp</a>' : '') + '</div>';
      } else {
        html = '<p>Aucune coque ne correspond à ces filtres' + (m ? ' pour l’' + esc(lab) : '') + '.</p><div class="ecx-empty__acts"><button type="button" class="ecx-empty__b is-dark" data-ecx-unstyle="*">Effacer les filtres</button></div>';
      }
      empty.innerHTML = html;
    }
    /* adresse de la page (liens partageables) */
    try {
      var u = new URL(location.href);
      if (m) { u.searchParams.set('modele', m); } else { u.searchParams.delete('modele'); }
      if (ss.length) { u.searchParams.set('style', ss.join(',')); } else { u.searchParams.delete('style'); }
      history.replaceState(history.state, '', u.toString());
    } catch (e) {}
  }

  /* ---------- modèle mémorisé (clé « ec-model », commune à tout le site) ---------- */
  function readStored() { if (W.ECModel) { var x = W.ECModel.read(); return x ? x.handle : ''; } try { return (W.localStorage.getItem('ec-model') || '').split('|')[0]; } catch (e) { return ''; } }
  var saving = false;
  function storeModel(h) {
    saving = true;
    var em = null;
    if (h) { em = (W.ECModel && W.ECModel.fromHandle(h)) || { handle: h, label: optText(mSel, h) || h }; }
    if (W.ECModel) { W.ECModel.save(em); }
    else { try { if (em) { W.localStorage.setItem('ec-model', em.handle + '|' + em.label); } else { W.localStorage.removeItem('ec-model'); } } catch (e) {} }
    saving = false;
  }
  function setModel(h, store) {
    h = hasOpt(mSel, h) ? h : '';
    state.m = h;
    if (store) { storeModel(h); }
    apply();
  }
  mSel.addEventListener('change', function () { setModel(mSel.value, true); });
  if (mClr) { mClr.addEventListener('click', function () { setModel('', true); try { mSel.focus({ preventScroll: true }); } catch (e) {} }); }
  d.addEventListener('ec:model', function (e) { if (saving) { return; } var h = e.detail && e.detail.handle ? e.detail.handle : ''; if (h !== state.m) { state.m = hasOpt(mSel, h) ? h : ''; apply(); } });
  W.addEventListener('storage', function (e) { if (e.key === 'ec-model') { var h = readStored(); state.m = hasOpt(mSel, h) ? h : ''; apply(); } });
  if (sortSel) { sortSel.addEventListener('change', apply); }

  /* ---------- panneau « Filtrer » ---------- */
  function styleName(s) { var o = fdlg && fdlg.querySelector('[data-ecx-sopt="' + s + '"] span'); return o ? o.textContent : s; }
  function paintFilter() {
    var n = 0;
    qa(fdlg, '[data-ecx-sopt]').forEach(function (lb) {
      var s = lb.getAttribute('data-ecx-sopt'), cnt = 0;
      cards.forEach(function (c) { if ((!state.m || c.models[state.m]) && c.s.indexOf(' ' + s + ' ') > -1) { cnt++; } });
      var cb = lb.querySelector('input'); cb.checked = !!draft[s];
      lb.querySelector('em').textContent = cnt;
      lb.hidden = !cnt && !draft[s];
    });
    cards.forEach(function (c) { if (passes(c, state.m, draft)) { n++; } });
    fdlg.querySelector('[data-ecx-fapply]').textContent = n ? 'Voir ' + plural(n) : 'Aucune coque';
  }
  function openFilter() {
    draft = JSON.parse(JSON.stringify(state.s)); paintFilter();
    if (fdlg.showModal) { fdlg.showModal(); } else { fdlg.setAttribute('open', ''); }
    d.documentElement.classList.add('ecx-lock');
  }
  function closeFilter() {
    if (fdlg.close) { fdlg.close(); } else { fdlg.removeAttribute('open'); }
    d.documentElement.classList.remove('ecx-lock');
    try { fBtn.focus({ preventScroll: true }); } catch (e) {}
  }
  fBtn.addEventListener('click', openFilter);
  fdlg.addEventListener('change', function (e) { var t = e.target; if (t && t.hasAttribute('data-ecx-scb')) { draft[t.value] = t.checked ? 1 : 0; if (!t.checked) { delete draft[t.value]; } paintFilter(); } });
  fdlg.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) { return; }
    if (t === fdlg || t.closest('[data-ecx-fclose]')) { closeFilter(); return; }
    if (t.closest('[data-ecx-freset]')) { draft = {}; paintFilter(); return; }
    if (t.closest('[data-ecx-fapply]')) { state.s = draft; apply(); closeFilter(); }
  });
  fdlg.addEventListener('cancel', function (e) { e.preventDefault(); closeFilter(); });

  /* ---------- clics sur la page ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) { return; }
    var un = t.closest('[data-ecx-unstyle]');
    if (un) { var s = un.getAttribute('data-ecx-unstyle'); if (s === '*') { state.s = {}; } else { delete state.s[s]; } apply(); return; }
    if (t.closest('[data-ecx-reset-all]')) { state.s = {}; setModel('', true); return; }
    var sw = t.closest('[data-ecx-color]');
    if (sw) {
      e.preventDefault();
      var li = sw.closest('[data-ecx-card]'), c = cards.filter(function (x) { return x.el === li; })[0]; if (!c) { return; }
      var name = sw.getAttribute('data-ecx-color');
      c.color = c.color === name ? '' : name;
      qa(c.sw, '[data-ecx-color]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ecx-color') === c.color ? 'true' : 'false'); });
      showColor(c); return;
    }
    var add = t.closest('[data-ecx-add]');
    if (add) {
      e.preventDefault();
      var li2 = add.closest('[data-ecx-card]'), c2 = cards.filter(function (x) { return x.el === li2; })[0];
      if (c2 && !add.disabled && add.getAttribute('aria-busy') !== 'true') { onCardButton(c2, add); }
    }
  });

  function onCardButton(c, btn) {
    var m = needsModel(c) && c.models[state.m] && c.models[state.m].av ? state.m : '';
    var list = colorsFor(c, m);
    var color = c.color && list.some(function (x) { return x.name === c.color; }) ? c.color : (list.length === 1 ? list[0].name : '');
    if (btn.getAttribute('data-mode') === 'add') {
      var v = variantFor(c, m, color);
      if (!v && c.mi < 0 && c.ci < 0) { v = c.vs.filter(function (x) { return x.av; })[0] || null; }
      if (v) { addToCart(v, btn).catch(function () { openPanel(c, m, color, btn); }); return; }
    }
    openPanel(c, m, color, btn);
  }

  /* ---------- ajout au panier ---------- */
  function addToCart(v, btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); }
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { throw new Error(j.description || j.message || ''); } return j; }); })
      .then(function () {
        try { d.dispatchEvent(new CustomEvent('lt:cart-changed')); } catch (e) {}
        toast('Ajouté au panier ✓ <a href="' + ROOT + 'cart">Voir le panier</a>');
      })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); } });
  }
  var toastT = 0;
  function toast(html) {
    var t = d.querySelector('.ecx-toast');
    if (!t) { t = d.createElement('div'); t.className = 'ecx-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); d.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('is-on');
    W.clearTimeout(toastT); toastT = W.setTimeout(function () { t.classList.remove('is-on'); }, 3400);
  }

  /* ---------- panneau de choix (modèle, couleur) ---------- */
  var pdlg = null, P = null, lastBtn = null;
  function panel() {
    if (pdlg) { return pdlg; }
    pdlg = d.createElement('dialog'); pdlg.className = 'ecx-pick'; pdlg.setAttribute('aria-labelledby', 'ecx-pick-t');
    pdlg.innerHTML = '<div class="ecx-pick__in"><button type="button" class="ecx-pick__x" data-ecx-pclose aria-label="Fermer"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '<div class="ecx-pick__hd"><span class="ecx-pick__ph"><img data-ecx-pimg alt="" width="80" height="100"></span><div><p class="ecx-pick__t" id="ecx-pick-t" data-ecx-ptitle></p><p class="ecx-pick__pr" data-ecx-pprice></p></div></div>' +
      '<p class="ecx-pick__note" data-ecx-pnote hidden></p><div data-ecx-popts></div>' +
      '<p class="ecx-pick__help"><button type="button" class="ecx-pick__hl" data-ecp-help>Je ne connais pas mon modèle</button></p>' +
      '<p class="ecx-pick__msg" data-ecx-pmsg role="alert"></p>' +
      '<button type="button" class="ecx-pick__add" data-ecx-pconfirm>' + BAG + '<span>Ajouter au panier</span></button>' +
      '<a class="ecx-pick__more" data-ecx-pmore href="#">Voir la fiche produit</a></div>';
    d.body.appendChild(pdlg);
    pdlg.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) { return; }
      if (t === pdlg || t.closest('[data-ecx-pclose]')) { closePanel(); return; }
      var mo = t.closest('[data-ecx-pm]');
      if (mo && !mo.disabled) {
        P.m = mo.getAttribute('data-ecx-pm'); P.note = '';
        if (P.color && !variantFor(P.c, P.m, P.color)) { P.color = ''; }
        var cl = colorsFor(P.c, P.m); if (!P.color && cl.length === 1) { P.color = cl[0].name; }
        storeModel(P.m); state.m = hasOpt(mSel, P.m) ? P.m : state.m; apply();
        renderPanel(); return;
      }
      var co = t.closest('[data-ecx-pc]');
      if (co && !co.disabled) { P.color = co.getAttribute('data-ecx-pc'); renderPanel(); return; }
      if (t.closest('[data-ecx-pconfirm]')) { confirmPanel(); }
    });
    pdlg.addEventListener('cancel', function (e) { e.preventDefault(); closePanel(); });
    return pdlg;
  }
  function openPanel(c, m, color, btn) {
    var g = panel(); lastBtn = btn;
    var note = '';
    if (needsModel(c) && !m && state.m && c.models[state.m] && !c.models[state.m].av) { note = 'Cette coque est épuisée pour votre ' + optText(mSel, state.m) + '.'; }
    P = { c: c, m: m, color: color, note: note };
    g.querySelector('[data-ecx-ptitle]').textContent = c.t;
    g.querySelector('[data-ecx-pmore]').setAttribute('href', c.url);
    renderPanel();
    if (g.showModal) { g.showModal(); } else { g.setAttribute('open', ''); }
    d.documentElement.classList.add('ecx-lock');
    var first = g.querySelector('.ecx-pick__o:not([disabled])[aria-pressed="false"]') || g.querySelector('[data-ecx-pclose]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
  }
  function closePanel() {
    if (!pdlg) { return; }
    if (pdlg.close) { pdlg.close(); } else { pdlg.removeAttribute('open'); }
    d.documentElement.classList.remove('ecx-lock');
    if (lastBtn) { try { lastBtn.focus({ preventScroll: true }); } catch (e) {} }
  }
  function renderPanel() {
    var c = P.c, html = '';
    if (needsModel(c) && c.mi > -1) {
      html += '<fieldset class="ecx-pick__g"><legend>Modèle d’iPhone</legend><div class="ecx-pick__vals">';
      c.morder.forEach(function (k) {
        var ok = c.vs.some(function (v) { return v.av && fits(c, v, k, P.color); }), on = P.m === k;
        html += '<button type="button" class="ecx-pick__o" data-ecx-pm="' + esc(k) + '" aria-pressed="' + on + '"' + (!ok && !on ? ' disabled' : '') + '>iPhone ' + esc(c.models[k].val) + '</button>';
      });
      html += '</div></fieldset>';
    }
    if (c.ci > -1) {
      var all = colorsFor(c, ''), avail = colorsFor(c, P.m);
      html += '<fieldset class="ecx-pick__g"><legend>Couleur' + (P.color ? ' : <b>' + esc(P.color) + '</b>' : '') + '</legend><div class="ecx-pick__vals">';
      all.forEach(function (x) {
        var ok = avail.some(function (y) { return y.name === x.name; }), on = P.color === x.name;
        var bg = x.img ? 'background-image:url(' + esc(sized(x.img, 160)) + ')' : 'background-color:' + (COLORS[String(x.name).toLowerCase()] || '#cfc8bb');
        html += '<button type="button" class="ecx-pick__o ecx-pick__c" data-ecx-pc="' + esc(x.name) + '" aria-pressed="' + on + '"' + (!ok && !on ? ' disabled' : '') + '><span class="ecx-pick__dot' + (x.img ? ' has-img' : '') + '" style="' + bg + '"></span>' + esc(x.name) + '</button>';
      });
      html += '</div></fieldset>';
    }
    pdlg.querySelector('[data-ecx-popts]').innerHTML = html;
    var v = variantFor(c, P.m, P.color);
    var any = v || c.vs.filter(function (y) { return y.av && fits(c, y, P.m, P.color); })[0] || c.vs[0];
    pdlg.querySelector('[data-ecx-pprice]').textContent = any ? dh(any.p) : '';
    var cx = P.color ? colorsFor(c, '').filter(function (x) { return x.name === P.color; })[0] : null;
    var src = (cx && cx.img) || c.src, im = pdlg.querySelector('[data-ecx-pimg]');
    if (src) { im.src = sized(src, 240); im.hidden = false; } else { im.hidden = true; }
    var note = pdlg.querySelector('[data-ecx-pnote]'); note.textContent = P.note; note.hidden = !P.note;
    pdlg.querySelector('.ecx-pick__help').hidden = !needsModel(c);
    var miss = [];
    if (needsModel(c) && !P.m) { miss.push('votre modèle d’iPhone'); }
    if (c.ci > -1 && !P.color) { miss.push('la couleur'); }
    var add = pdlg.querySelector('[data-ecx-pconfirm]');
    add.disabled = !!miss.length || !v;
    add.querySelector('span').textContent = miss.length ? 'Choisissez ' + miss.join(' et ') : 'Ajouter au panier';
    pdlg.querySelector('[data-ecx-pmsg]').textContent = '';
  }
  function confirmPanel() {
    var v = variantFor(P.c, P.m, P.color), btn = pdlg.querySelector('[data-ecx-pconfirm]');
    if (!v) { renderPanel(); return; }
    if (P.color && P.c.color !== P.color) { P.c.color = P.color; renderSwatches(P.c); showColor(P.c); }
    addToCart(v, btn).then(function () { closePanel(); }).catch(function (err) { pdlg.querySelector('[data-ecx-pmsg]').textContent = (err && err.message) || 'L’ajout n’a pas abouti. Veuillez réessayer.'; });
  }

  /* ---------- démarrage : aucun modèle par défaut ; seulement celui choisi par le client (lien ou mémoire) ---------- */
  try {
    var q = new URL(location.href).searchParams, qm = (q.get('modele') || '').toLowerCase(), qs = q.get('style') || '';
    if (qm && hasOpt(mSel, qm)) { state.m = qm; storeModel(qm); }
    else { var sv = readStored(); if (hasOpt(mSel, sv)) { state.m = sv; } }
    qs.split(',').forEach(function (s) { s = s.trim(); if (s && fdlg.querySelector('[data-ecx-sopt="' + s + '"]')) { state.s[s] = 1; } });
  } catch (e) {}
  apply();
  W.addEventListener('pageshow', function (e) { if (e.persisted) { var h = readStored(); state.m = hasOpt(mSel, h) ? h : ''; apply(); } });
})();
